import React from "react";
import { Box } from "@mui/material";
import Avatar from "components/v2/common/Avatar";
import { getTimeAgo, parseHtml, stripNumbersFromUsername } from "_helpers";
import _ from "lodash";
import ReactionEntry from "./ReactionEntry";

export default function CommentItem({ conversation, sourceName, author }) {
  const dateCreated = _.get(conversation, "conversation.0.createdDate");
  let text = parseHtml(conversation?.text, sourceName);
  const replies = _.get(conversation, "_embedded.replies");

  const CommentContent = ({ author, dateCreated, text, withReaction }) => {
    return (
      <>
        <Box>
          <Avatar
            src={undefined}
            userName={author}
            alt={author}
            background={"teal"}
            initialsCount={2}
            style={styles.avatar}
          />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Box sx={styles.details}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {author && <Box sx={styles.authorName}>{author}</Box>}
            </Box>

            <Box as="p" sx={styles.time}>
              {getTimeAgo(dateCreated)}
            </Box>
          </Box>

          <Box sx={styles.commentText}>{text}</Box>

          {withReaction && (
            <ReactionEntry
              sourceName={sourceName}
              conversation={conversation}
            />
          )}
        </Box>
      </>
    );
  };

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.commentContainer}>
        <CommentContent
          author={author}
          dateCreated={dateCreated}
          text={text}
          withReaction={true}
        />
      </Box>

      {replies?.length > 0 &&
        replies?.map((item) => {
          const replyAuthor = stripNumbersFromUsername(_.get(item, "author"));
          const dateCreated = _.get(item, "dateCreated");
          let replyText = parseHtml(item?.text, sourceName);

          return (
            <Box sx={styles.replyContainer} key={item.id}>
              <CommentContent
                author={replyAuthor}
                dateCreated={dateCreated}
                text={replyText}
                withReaction={false}
              />
            </Box>
          );
        })}
    </Box>
  );
}

const styles = {
  wrapper: {
    backgroundColor: "#ffffff",
    gap: "13px",
    borderRadius: "16px",
    boxShadow: "rgba(18, 38, 27, 0.05) 0px 1px 3px",
    padding: "15px",
  },
  commentContainer: {
    display: "flex",
    alignItems: "flex-start",
    gap: "13px",
  },
  replyContainer: {
    borderLeft: "2px solid rgb(236, 231, 223)",
    marginLeft: "40px",
    pl: "10px",
    pt: "15px",
    display: "flex",
    alignItems: "flex-start",
    gap: "13px",
  },
  commentText: {
    color: "#33413a",
    mt: 0.5,
    fontFamily: "FustatRegular",
    fontSize: "14px",
  },
  details: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "space-between",
  },
  time: {
    color: "#98a29a",
    m: 0,
    fontFamily: "FustatMedium",
    fontSize: "11px",
    textAlign: "right",
  },
  authorName: {
    color: "#1a2b20",
    m: 0,
    fontFamily: "FustatBold",
    fontSize: "16px",
  },
  userName: {
    color: "#98a29a",
    fontFamily: "FustatMedium",
    fontSize: "12px",
    display: "inline-block",
  },
  avatar: {
    width: "40px",
    height: "40px",
    borderRadius: "5px",
    fontSize: "14px",
    textTransform: "capitalize",
    borderRadius: "9999px",
  },
};
